/**
 * @created on 2017/10/27
 * @author laixinyu <laixinyualex@gmail.com>
 **/
import './style.scss'

import { axios as $http, router } from 'cm'
import qs from 'qs'
import APIS from './module/apis'
import { wxOpenApp } from '../../../frontend-lib/component/wxToAPP'

import {
  versionfunegt,
  GetQueryString,
  compareVersion
} from '../../../public-resource/libs/utils/index'

import { setScrollTop, wxConfigOrigin } from 'src/frontend-lib/tools/utils'
import share from '../../../public-resource/components/Share'

// import Bridge from '../../../public-resource/libs/Bridge/Bridge';
import { loadScript } from '../../../public-resource/libs/utils/index'
import Bridge from 'src/frontend-lib/lib/Bridge'

import commentCreator from '../../../page-resource/lesson/compoents/comment/index'
import CommentModel from '../../../page-resource/lesson/compoents/commentModel/index'
import Swiper from '../../../public-resource/components/swiper/swiper'
// import "../../../public-resource/components/swiper/swiper.css"
import {
  getEnvHost,
  getPlatform,
  getRunningEnv
} from 'src/frontend-lib/tools/getPlatform'
// 引入播放器
import player from './components/player/index'
import ALIPlayer from './components/aliplayer'
import livePlayer from './components/player/old_play'

// import audio from './components/audio/index';
import scroll from './components/scroll/index'
import nativeDownloadInfos from '../detail/components/catalog/nativeDownload'
import monitor from '../../../frontend-lib/lib/monitor'
import {
  getCommandRequest,
  handleCopy
} from '../../../public-resource/libs/appCommand/command'
import Clipboard from 'clipboard'
import { clockInit, renderWXClockTpl } from './components/clock'
import { isLogin } from '../../../page-resource/lesson/utils'

import initConsultYinliu from './components/consult'
import initUpgradeAppVersionTips from './components/upgradeAppVersionTips'

import { onPageViewTrack, onDetailTrack, onBuyTrack } from './track'

// ua
const UA = window.navigator.userAgent.toUpperCase()
// 平台判断
const $platform = getPlatform()
// 判断是否APP环境
const IS_APP = window.$platform.isYixinliApp
const IS_IOS = /(iPhone|iPad|iPod|iOS)/i.test(UA)
const IS_MOBILE = window.$platform.isMobile

// 付费类型
const PAY_TYPE = +window.baseInfo.is_free === 1 ? '免费' : '付费'
let isAliPay = +GetQueryString('isAliPay') === 1
let isWebviewMp = +GetQueryString('isWebviewMp') === 1
var isTouchOne = true // 定义防止第二次点击

let SHARE

const comment = commentCreator(
  window.baseInfo.user_id !== 0,
  page =>
    document.querySelector(`#comment-list-${page === 1 ? 'top' : 'bottom'}`),
  { periodId: window.baseInfo.keshi_id }
)

// 查看全部详情
function showDetail() {
  if (+window.baseInfo.is_join === 0 && +window.baseInfo.is_experience === 0) {
    window.toast('非试看内容，请参加课程后再查看', 3000)
    return
  }

  document.querySelector('.video-desc').classList.toggle('video-desc-hidden')
}

// 参加课程逻辑
async function join() {
  if (!isLogin(window.baseInfo.free_success_back_url)) {
    return
  }

  if (+window.baseInfo.is_free === 1) {
    if (!isTouchOne) {
      return
    }
    isTouchOne = false
    let { data } = await $http.get(`${window.baseInfo.join_url}`)

    if (+data.code === 0 || +data.code === 10) {
      // APP下免费参加成功后直接关闭webview
      if (IS_APP) {
        window.myBrige.call('reloadWebView')
        window.myBrige.call('cancelWebView')
      }

      const href = data.data.url
      router.openWebView(href)
    } else {
      isTouchOne = true
    }
  } else {
    const channel_id = GetQueryString('channel_id') || ''
    let buyUrl = window.baseInfo.pay_url + '&channel_id=' + channel_id
    if (IS_APP) {
      window.myBrige.call('openWebView', {
        url: buyUrl
      })
    } else {
      const href = buyUrl
      router.openWebView(href)
    }
  }
}

//团购倒计时
let _restTime = 999999 //parseInt(window.baseInfo.grouponExpiredTime)
if (
  window.baseInfo.isGrouponLesson.toString() === '1' &&
  document.querySelector('.grounpon-bottom-fixed-wrap')
) {
  let day, _hour, _minute, _second, hour, minute, second
  let countdownDay = document.querySelector('.countdown-day')
  let countdownHour = document.querySelector('.countdown-hour')
  let countdownMinute = document.querySelector('.countdown-minute')
  var countdown = setInterval(function() {
    if (_restTime >= 0) {
      day = Math.floor(_restTime / (3600 * 24))
      _hour = Math.floor((_restTime - day * 3600 * 24) / 3600)
      _minute = Math.floor((_restTime - day * 24 * 3600 - _hour * 3600) / 60)
      _second = _restTime - day * 24 * 3600 - _hour * 3600 - _minute * 60
      hour = _hour < 10 ? '0' + _hour : _hour
      minute = _minute < 10 ? '0' + _minute : _minute
      second = _second < 10 ? '0' + _second : _second
      _restTime--

      countdownDay.innerText = day
      countdownHour.innerText = hour
      countdownMinute.innerText = minute
    } else {
      clearInterval(countdown)
      document.querySelector('.grounpon-bottom-fixed-wrap').style.display =
        'none'
      document.querySelector('.grounpon-btn').style.display = 'none'
      document.querySelector('.mygrounp-btn').style.display = 'none'
    }
  }, 1000)
}

// 加入拼团逻辑
function grounpon() {
  if (!isLogin(window.location.href.split('?')[0])) {
    return
  }

  if (_restTime > 0) {
    let channelId = 522
    let searchParamsList = new URLSearchParams(window.location.search)
    console.log(searchParamsList)
    if (searchParamsList.has('lx_channel_id')) {
      channelId = searchParamsList.get('lx_channel_id')
    }

    let targetUrl = `${location.protocol}${APIS.staticHost}/msite/index.html#/lesson-start-group/${window.baseInfo.lesson_id}?channelId=${channelId}`
    if (IS_APP) {
      window.myBrige.call('openWebView', {
        url: targetUrl
      })
    } else {
      window.location.href = targetUrl
    }
  } else {
    window.toast('拼团时间已结束')
  }
}

// 我的拼团逻辑
function mygrounpon() {
  if (!isLogin(window.location.href.split('?')[0])) {
    return
  }
  let channelId = 522
  let searchParamsList = new URLSearchParams(window.location.search)
  if (searchParamsList.has('lx_channel_id')) {
    channelId = searchParamsList.get('lx_channel_id')
  }

  let targetUrl = `${location.protocol}${APIS.staticHost}/msite/index.html#/lesson-group-detail/${window.baseInfo.lesson_id}?teamId=${window.baseInfo.grouponTeamId}&channelId=${channelId}`

  if (IS_APP) {
    window.myBrige.call('openWebView', {
      url: targetUrl
    })
  } else {
    window.location.href = targetUrl
  }
}

// 分享功能
async function shareInit(e) {
  let isShow = e.classList.toggle('active')

  if (!SHARE) {
    let replacedUrl =
      window.baseInfo.wx_share_config.url.replace(
        window.location.protocol + getEnvHost(`//m.xinli001.com`),
        wxConfigOrigin(
          require('../../../../yxlConfig.json'),
          'XY_ORIGIN',
          'm_safe'
        )
      ) + '&is_share=1&sharetype=app'
    let $config = {
      url: replacedUrl,
      cover:
        'https://ossimg.xinli001.com/20200309/9c00bc9481c1ddf25fddcc94f2f451ae.png',
      content: '人人都能学的心理学，壹心理学堂诚意出品。',
      title: window.baseInfo.wx_share_config.title,
      callback: function(channel) {
        // 埋点
        let channelName = ''

        switch (channel) {
          case 'link':
            channelName = '复制链接'
            break
          case 'wechat':
            channelName = '微信'
            break
          case 'qzone':
            channelName = 'qq空间'
            break
          case 'qq':
            channelName = 'qq'
            break
          case 'weibo':
            channelName = '微博'
            break
          default:
            channelName = '未知'
            break
        }

        // 埋点

        window.yxl.stat.send({
          name: '学院-交互行为',
          properties: {
            业务: '课程播放页',
            行为: '点击',
            对象: '课程播放页-分享',
            分享渠道: channelName,
            课程类型:
              +window.baseInfo.is_experience === 1
                ? '免费试听'
                : +window.baseInfo.is_free === 1
                ? '免费课程'
                : '付费课程'
          }
        })
      }
    }

    SHARE = new share($config)

    showModal(isShow)
  } else {
    showModal(isShow)
  }

  /**
   * 显示分享组件
   * @param show
   */
  function showModal(show) {
    if (show) {
      SHARE.show()
    } else {
      SHARE.hide()
    }
  }
}

// 微信分享初始化
async function wxShareInit() {
  try {
    let _url = window.encodeURIComponent(
      `${window.location.href.split('#')[0]}`
    )
    // let { data } = await $http.get(
    //   `${APIS.getWXShareConfig}?url=${_url}&name=college`
    // )

    let { data } = await $http.get(
      `${APIS.getWXShareConfig}?url=${_url}&name=yida`
    )
    if (+data.code === 0) {
      window.baseInfo.wx_config = data.data
      // 微信环境调用JSSDK
      if (window.baseInfo && window.baseInfo.wx_config) {
        if ($platform.isWechat) {
          loadScript(
            '//res.wx.qq.com/open/js/jweixin-1.6.0.js',
            _shareInit.bind(this)
          )
        } else if (IS_APP) {
          appShare()
        }
      }
    }
  } catch (e) {
    console.log(e)
  }

  function _shareInit() {
    wxShare()
  }

  function wxShare() {
    var wx_config = window.baseInfo.wx_config

    var _config = {
      debug: wx_config.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: wx_config.appId, // 必填，公众号的唯一标识
      timestamp: wx_config.timestamp, // 必填，生成签名的时间戳
      nonceStr: wx_config.nonceStr, // 必填，生成签名的随机串
      signature: wx_config.signature, // 必填，签名，见附录1
      jsApiList: [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'onMenuShareQZone',
        'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
        'updateTimelineShareData' // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
      ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp']
    }

    // 微信基本配置信息
    wx.config(_config)

    // 分享需要讲课时标题做title 课程标题做描述
    var shareInfo = window.baseInfo.wx_share_config.second_title
    var shareDesc = '人人都能学的心理学，壹心理学堂诚意出品。'
    var shareImgUrl =
      'https://ossimg.xinli001.com/20200309/9c00bc9481c1ddf25fddcc94f2f451ae.png'
    var shareUrl =
      window.baseInfo.wx_share_config.url.replace(
        window.location.protocol + getEnvHost(`//m.xinli001.com`),
        wxConfigOrigin(
          require('../../../../yxlConfig.json'),
          'XY_ORIGIN',
          'm_safe'
        )
      ) + '&is_share=1&sharetype=mobile'

    // 如果是专业课的文本课时，分享地址是固定的
    shareUrl = handleTextLessonShareUrl(
      shareUrl,
      '&is_share=1&sharetype=mobile'
    )

    wx.ready(function() {
      // 分享到朋友圈
      wx.onMenuShareTimeline({
        title: shareInfo, // 分享标题
        link: shareUrl, // 分享链接
        desc: shareDesc,
        imgUrl: shareImgUrl, // 分享图标
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      })

      // 分享给朋友
      wx.onMenuShareAppMessage({
        title: shareInfo, // 分享标题
        link: shareUrl, // 分享链接
        desc: shareDesc,
        imgUrl: shareImgUrl, // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      })

      // 分享到qq
      wx.onMenuShareQQ({
        title: shareInfo, // 分享标题
        link: shareUrl, // 分享链接
        desc: shareDesc,
        imgUrl: shareImgUrl, // 分享图标
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      })

      // 分享到腾讯微博
      wx.onMenuShareWeibo({
        title: shareInfo, // 分享标题
        link: shareUrl, // 分享链接
        desc: shareDesc,
        imgUrl: shareImgUrl, // 分享图标
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      })

      // 分享到qq空间
      wx.onMenuShareQZone({
        title: shareInfo, // 分享标题
        link: shareUrl, // 分享链接
        desc: shareDesc,
        imgUrl: shareImgUrl, // 分享图标
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      })
      wx.updateAppMessageShareData({
        title: shareInfo, // 分享标题
        link: shareUrl, // 分享链接
        desc: shareDesc,
        imgUrl: shareImgUrl, // 分享图标
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      })
      wx.updateTimelineShareData({
        title: shareInfo, // 分享标题
        link: shareUrl, // 分享链接
        desc: shareDesc,
        imgUrl: shareImgUrl, // 分享图标
        success: function() {
          // 用户确认分享后执行的回调函数
        },
        cancel: function() {
          // 用户取消分享后执行的回调函数
        }
      })
      wxOpenApp.init()
      renderWXClockTpl()
    })
  }

  function appShare() {
    window.Bridge = Bridge

    window.myBrige = new Bridge({
      methods: [
        {
          method: 'topFuncBtn',
          callback(ops) {
            if (ops.name === 'shareReportBtn') {
              // 分享需要讲课时标题做title 课程标题做描述

              let $config = {
                link: `${window.baseInfo.wx_share_config.url}&sharetype=app`,
                imgUrl: window.baseInfo.wx_share_config.cover,
                desc: window.baseInfo.wx_share_config.title,
                title: window.baseInfo.wx_share_config.second_title
              }
              // 如果是专业课的文本课时，分享地址是固定的
              $config.link = handleTextLessonShareUrl(
                $config.link,
                '&sharetype=app'
              )

              window.myBrige.call('shareReport', $config)
            }
          }
        }
      ]
    })

    window.myBrige.call('setTitle', {
      title: document.title
    })

    window.myBrige.call('topFuncBtnConfig', {
      btnList: [
        {
          name: 'shareReportBtn',
          visible: 1
        }
      ]
    })
  }
}

// 判断是否登录
// function isLogin(backURL) {
//   if (+window.baseInfo.user_id === 0) {
//     window.toast('请先注册登录，页面即将跳转...', 3000)

//     setTimeout(() => {
//       let _href = IS_APP
//         ? 'yixinli://open_user_login'
//         : `${APIS.login}?next=${encodeURIComponent(
//             backURL || window.location.href
//           )}`

//       window.location.href = _href
//     }, 3000)

//     return false
//   }

//   return true
// }

// 滑动提示，仅提示一次
function touchSlide() {
  const cacheKey = '__lesson_tips_showed__'
  if (IS_MOBILE) {
    let showed = false
    try {
      showed = window.localStorage.getItem(cacheKey)
    } catch (e) {
      console.log(e)
    }
    if (showed) {
      return false
    }
    window.toast('左右滑动屏幕，可调节进度~', 3000)
    try {
      window.localStorage.setItem(cacheKey, 'true')
    } catch (e) {
      console.log(e)
    }
  }
}

// 事件初始化
function initEvents() {
  // 点赞功能
  comment.initEvents()
  // const COMMENT_ROOT = document.querySelector('.comment-wrap');

  // COMMENT_ROOT && COMMENT_ROOT.addEventListener('click', e => {
  //   let el = e.target;

  //   while (el !== COMMENT_ROOT) {
  //     // 点赞
  //     if (el.classList.contains('like-action')) {
  //       like(el);
  //       break;
  //     } else if (el.classList.contains('loading-tip')) {
  //       commentLoadMore(el);
  //       break;
  //     } else {
  //       el = el.parentNode;
  //     }
  //   }
  // });

  // const SHOW_DETAIL_BTN = document.querySelector('.retractable-wrap');
  let stopDoubleClickTimer = null
  let stop = false
  document.addEventListener('click', e => {
    if (e.target.classList.contains('retractable-wrap')) {
      if (stop) return
      stop = true
      showDetail()
      stopDoubleClickTimer = setTimeout(() => {
        stop = false
      }, 200)
    }
  })

  // 参加课程事件绑定
  const JOIN_BTN = document.querySelector('.join-btn')
  JOIN_BTN &&
    JOIN_BTN.addEventListener('click', e => {
      // 埋点
      window.yxl.stat.send({
        name: '学院-交互行为',
        properties: {
          业务: '课程播放页',
          行为: '点击',
          对象: '课程播放页-立即参加',
          分类名称: window.baseInfo.tag_name,
          费用类型: `${PAY_TYPE}课程`,
          课程名称: window.baseInfo.lesson_title
        }
      })
      onBuyTrack()

      join()
    })

  // 我要开团
  let grounponBtn = document.querySelector('.bottom-fixed-wrap .grounpon-btn')
  if (grounponBtn) {
    grounponBtn.addEventListener('click', e => {
      grounpon()
    })
  }
  let dialogBox = document.querySelector('.dialog-bg'),
    fixedWrap = document.querySelector('.fixed-wrap .full-box'),
    dialogBoxDes = document.querySelector('.dialog-bg .des span'),
    cancelDialog = document.querySelector('.dialog-bg .icon-guanbidanchuang'),
    dialogTitle = document.querySelector('.dialog-bg .title')
  if (dialogBoxDes) {
    dialogBoxDes.innerText = $platform.isWechat
      ? '长按识别二维码'
      : '截图发送至微信长按识别二维码'
  }
  if (fixedWrap && dialogBox) {
    fixedWrap.addEventListener('click', e => {
      dialogTitle.innerText = '加助教微信了解'
      dialogBox.style.display = 'block'
    })
  }
  if (cancelDialog) {
    cancelDialog.addEventListener('click', e => {
      dialogBox.style.display = 'none'
    })
  }

  // 我的开团
  let mygrounponBtn = document.querySelector('.bottom-fixed-wrap .mygrounp-btn')
  if (mygrounponBtn) {
    mygrounponBtn.addEventListener('click', e => {
      mygrounpon()
    })
  }

  // const DEFAULT_COVER_BTN = document.querySelector('.default-cover');

  // DEFAULT_COVER_BTN && DEFAULT_COVER_BTN.addEventListener('click', e => {
  document.addEventListener('click', e => {
    if (e.target.classList.contains('default-cover')) {
      window.toast('非试听内容，请参加课程后再播放。', 3000)

      // 埋点

      window.yxl.stat.send({
        name: '学院-交互行为',
        properties: {
          业务: '课程播放页',
          行为: '点击',
          对象: '课程播放页-播放按钮',
          课程类型:
            +window.baseInfo.is_experience === 1
              ? '免费试听'
              : +window.baseInfo.is_free === 1
              ? '免费课程'
              : '付费课程',
          课程名称: window.baseInfo.lesson_title
        }
      })
    }
  })

  // 绑定点击类toast & 埋点事件
  document.addEventListener('click', e => {
    let el = e.target

    while (el !== document) {
      if (!el) {
        return
      }

      let classList = el.classList
      if (classList.contains('class-link-btn') && el.dataset.flag !== '6') {
        skipClass(e)

        break
      }

      if (classList.contains('class-item-link')) {
        e.preventDefault()

        // 埋点
        window.yxl.stat.send({
          name: '学院-交互行为',
          properties: {
            业务: '课程播放页',
            行为: '点击',
            对象: '课程播放页-课程',
            课程名称: window.baseInfo.lesson_title
          }
        })

        window.location.href = el.getAttribute('href')
      }

      if (classList.contains('go-score-link')) {
        e.preventDefault()

        // 埋点

        window.yxl.stat.send({
          name: '学院-交互行为',
          properties: {
            业务: '课程播放页',
            行为: '点击',
            对象: '课程播放页-评价课程'
          }
        })

        window.location.href = el.getAttribute('href')
      }

      el = el.parentNode
    }
  })

  // 由于 客户端内，webview高度需要减去视频高度，QA反馈提示框不居中
  // 客户端环境且非直播时，做样式调整
  if (IS_APP && +window.baseInfo.thirdPriorityFirst !== 1) {
    document.body.classList.add('is_app')
  }

  if (+window.baseInfo.thirdPriorityFirst === 1 || isAliPay) {
    if (document.querySelector('.link-more')) {
      document.querySelector('.link-more').style.display = 'none'
    }
  } else {
    if (document.querySelector('.link-more')) {
      document
        .querySelector('.link-more')
        .addEventListener('click', function(e) {
          onDetailTrack()
          const href = this.getAttribute('href')
          window.location.href = href
          e.preventDefault()
        })
    }
  }
}

// 课程列表初始化
function initSwiper() {
  function getNavActive() {
    let $target = document.querySelector('.nav-list')
    if ($target) {
      let $actives = $target.querySelectorAll('.swiper-slide')
      for (let i = 0; i < $actives.length; i++) {
        if ($actives[i].classList.contains('active')) {
          return i
        }
      }
    }
  }

  let $activeIndex = getNavActive()
  const spaceBetween = Math.ceil(
    window.lib.flexible.rem2px('0.26667rem').replace('px', '')
  )
  setTimeout(
    () => {
      var swiper = new Swiper('.swiper-container', {
        initialSlide: $activeIndex || 0,
        slidesPerView: 2.2,
        spaceBetween: spaceBetween
      })
      const navListItems = document.querySelectorAll(
        '.video-nav .nav-list > li > a'
      )
      for (let i = 0; i < navListItems.length; i++) {
        navListItems[i].onclick = function(e) {
          const hasLock = this.parentNode.classList.contains('lock')
          // 判断特殊的直播状态
          const ifNotStartLive = this.parentNode.classList.contains(
            'notStartLive'
          )
          const ifLiveEnd = this.parentNode.classList.contains('liveEnd')
          const is_ali_video = this.getAttribute('data-is-ali-video')
          const _version =
            GetQueryString('_version') ||
            GetQueryString('_version', window.location.hash)
          if (this.getAttribute('data-matter-id') <= 0) {
            return
          }
          if (hasLock) {
            window.toast('非试听内容，请先购买')
            e.preventDefault()
          } else if (ifNotStartLive) {
            window.toast('直播未开始，请耐心等待')
            e.preventDefault()
          } else if (ifLiveEnd) {
            window.toast('直播已结束，录播上传中...')
            e.preventDefault()
          } else {
            if (
              IS_APP &&
              is_ali_video == 0 &&
              !versionfunegt(_version, '5.2.3')
            ) {
              let message = `IS_APP:${IS_APP};is_ali_video:${is_ali_video};version:${_version}`
              monitor.stat({
                from: 'app_version',
                level: 'error',
                error: 'js',
                msg: message
              })
            }
            e.preventDefault()
            let href = this.getAttribute('href')
            if (isWebviewMp) {
              href += '&isWebviewMp=1'
            }
            if (isAliPay) {
              href += '&isAliPay=1'
            }
            window.location.replace(href)
            // window.toast('app版本过旧，无法观看该视频，请升级APP。')
            // setTimeout(() => {
            //   updateOrDownLoadApp()
            // }, 1500)
            // e.preventDefault()
          }
        }
      }
    },
    process.env.NODE_ENV === 'production' ? 0 : 200
  )
}

// 跳转上下期逻辑
function skipClass(e) {
  let el = e.target

  if (el.tagName.toUpperCase() !== 'A') {
    el = el.parentNode
  }

  if (el.getAttribute('data-matter-id') <= 0) {
    e.preventDefault()

    window.toast('老师正在努力录制中，请耐心等待哦！', 3000)
  } else if (IS_APP) {
    // 去除当前webView打开逻辑
  }
}

function initComment() {
  // 先加载第一页评论数据

  // console.log(document.querySelector('.bottom-fixed-wrap .fixed-wrap').childNodes)
  if (!document.querySelector('.bottom-fixed-wrap')) {
    document.querySelector('#top-wrapper').style.bottom = 0
    document.querySelector('#bottom-wrapper') &&
      (document.querySelector('#bottom-wrapper').style.bottom = 0)
  }

  return comment
    .commentLoadMore()
    .then(() => {
      if (document.querySelectorAll('.comment-item').length >= 10) {
        return comment.commentLoadMore()
      } else {
        return true
      }
    })
    .then(() => {
      const renderScroll2 =
        document.querySelectorAll('.comment-item').length > 10
      // const renderScroll2 = Number(window.baseInfo.period_reply_num) > 5
      if (renderScroll2) {
        document.querySelector(
          '#top-wrapper .comment-list-loading-tip'
        ).style.display = 'none'
        document.querySelector('#pull-tips-up').style.display = 'block'
      } else {
        document.querySelector(
          '#top-wrapper .comment-list-loading-tip'
        ).style.display = 'block'
        document.querySelector('#pull-tips-up').style.display = 'none'
      }
      return scroll(renderScroll2)
    })
    .then(({ scroll, scroll2 }) => {
      // 如果初始化了 加载第二页评论数据，绑定事件
      if (scroll2) {
        scroll2.on('scrollEnd', () => {
          const { y, maxScrollY } = scroll2
          if (y <= maxScrollY + 100) {
            // load 完之后刷新
            comment.commentLoadMore().then(() => scroll2.refresh())
          }
        })
      }

      if (document.querySelector('.comment-puppet .yxl-font')) {
        document
          .querySelector('.comment-puppet .yxl-font')
          .addEventListener('click', () => {
            scroll.scrollToElement('.comment-introduce')
          })
      }

      document.body.removeEventListener('touchmove', preventEvent)
      document.body.removeEventListener('scroll', preventEvent)

      if (IS_APP) {
        try {
          // 引流咨询需求
          const { lesson_id, keshi_id } = window.baseInfo
          let historyStyle
          initConsultYinliu({
            lesson_id,
            keshi_id,
            onDetailShow: teacher => {
              historyStyle = document.body.style
              document.body.style +=
                'overflow: hidden; position: fixed; height: 100%; width: 100%;'

              window.yxl.stat.send({
                name: '学院-交互行为',
                properties: {
                  业务: '课程播放页',
                  行为: '点击',
                  对象: '播放页-课程导咨询广告',
                  课程名称: window.baseInfo.lesson_title,
                  被点击元素文字: teacher.copywriting,
                  咨询师姓名: teacher.name
                }
              })
            },
            onDetailHide: () => {
              document.body.style = historyStyle
            }
          })
            .then(consultYinliu => {
              if (consultYinliu) {
                // scroll.on('scroll', consultYinliu.onBodyScroll)
                scroll.on('scrollStart', () => consultYinliu.onBodyScroll(true))
                scroll.on('scrollEnd', () => consultYinliu.onBodyScroll(false))
                scroll2 &&
                  scroll2.on('scrollStart', () =>
                    consultYinliu.onBodyScroll(true)
                  )
                scroll2 &&
                  scroll2.on('scrollEnd', () =>
                    consultYinliu.onBodyScroll(false)
                  )
              }
            })
            .catch(e => {
              console.log(`eeee2e`, e)
            })
        } catch (e) {
          console.log(`eeeee`, e)
        }
      }
    })
    .catch(e => {
      console.log(e)
      scroll()

      document.body.removeEventListener('touchmove', preventEvent)
      document.body.removeEventListener('scroll', preventEvent)
    })
}

function initPlayer() {
  // debugger
  // 初始化播放器
  // 选择视频还是音频
  let playerWrap = document.querySelector('#video-player-container')

  let isLive = window.baseInfo.thirdPriorityFirst

  if (+isLive === 1) {
    if (
      +window.baseInfo.is_experience !== 1 &&
      +window.baseInfo.is_join !== 1 &&
      window.baseInfo.player &&
      +window.baseInfo.player.daily_lesson !== 1
    ) {
      // 未参加且非试听逻辑
      let playWrap = document.querySelector('#video-player-container')
      // playWrap.style.backgroundImage = `url(${window.baseInfo.default_cover})`;
      playWrap.style.backgroundImage = `url(${window.baseInfo.default_cover})`
      playWrap.classList.add('default-cover')
    } else {
      livePlayer(playerWrap)
    }
    return
  }

  const baseInfo = window.baseInfo
  const isVideo = Boolean(+baseInfo.is_video)
  const aliPlayerConfig = Object.assign(
    { isVideo, isAudio: !isVideo },
    isVideo ? baseInfo.player : baseInfo.audio
  )
  const isUsingAliplayer = Boolean(aliPlayerConfig.url)

  if (
    +window.baseInfo.is_experience !== 1 &&
    +window.baseInfo.is_join !== 1 &&
    window.baseInfo.player &&
    +window.baseInfo.player.daily_lesson !== 1
  ) {
    let revision
    // 如果不加判断会导致报错
    if (IS_APP) {
      revision = window.$platform.yixinliAPPVersion
    }

    if (IS_APP && compareVersion(revision, '4.9.1') >= 0) {
      // 4.9.1以后改用原生播放器,不做任何操作
      console.log('已使用原生播放器')
    } else {
      // 未参加且非试听逻辑
      let playWrap = document.querySelector('#video-player-container')

      // playWrap.style.backgroundImage = `url(${window.baseInfo.default_cover})`;
      playWrap.style.backgroundImage = `url(${window.baseInfo.default_cover})`
      playWrap.classList.add('default-cover')
    }
  } else if (IS_APP) {
    // app渲染逻辑

    // 获得APP版本号
    let revision = window.$platform.yixinliAPPVersion

    if (compareVersion(revision, '4.9.1') >= 0) {
      // 4.9.1以后改用原生播放器,不做任何操作
      console.log('已使用原生播放器')
    } else if (+window.baseInfo.is_video === 1) {
      /*
       * 由于阿里视频播放器在安卓客户端下存在很多问题，所以在安卓客户端下跳转到原生播放页
       *
       * */
      if (window.$platform.isAndroid) {
        let playWrap = document.querySelector('#video-player-container')

        playWrap.style.backgroundImage = `url(${window.baseInfo.default_cover})`
        playWrap.classList.add('app-default-cover')

        playWrap.addEventListener('click', e => {
          e.preventDefault()

          // 埋点
          window.yxl.stat.send({
            name: '学院-交互行为',
            properties: {
              业务: '课程播放页',
              行为: '点击',
              对象: '课程播放页-播放按钮',
              课程类型:
                +window.baseInfo.is_experience === 1
                  ? '免费试听'
                  : +window.baseInfo.is_free === 1
                  ? '免费课程'
                  : '付费课程',
              课程名称: window.baseInfo.lesson_title
            }
          })

          window.location.href = window.baseInfo.old_play_url
        })
      } else {
        // use aliplayer
        if (isUsingAliplayer) {
          return new ALIPlayer(playerWrap, aliPlayerConfig)
        }
        player(playerWrap)
      }
    } else {
      // use aliplayer
      if (isUsingAliplayer) {
        return new ALIPlayer(playerWrap, aliPlayerConfig)
      }
      player(playerWrap)
    }
  } else {
    // use aliplayer
    if (isUsingAliplayer) {
      return new ALIPlayer(playerWrap, aliPlayerConfig)
    }
    // m站渲染逻辑
    if (+window.baseInfo.is_video === 1) {
      player(playerWrap)
    } else {
      player(playerWrap)
    }
  }
}

function handleTextLessonLayout() {
  // 让容器布满一屏
  const topWrapper = document.querySelector('#top-wrapper')
  if (topWrapper) {
    topWrapper.style.height = `${window.innerHeight}px`
  }
  // 隐藏评价
  const bottomWrapper = document.querySelector('#bottom-wrapper')
  if (bottomWrapper) {
    bottomWrapper.style.display = 'none'
  }
  // 隐藏底部按钮
  const bottomBar = document.querySelector('.bottom-fixed-wrap')
  if (bottomBar) {
    bottomBar.style.display = 'none'
  }
  // 隐藏精选留言
  const commentWrap = document.querySelector('#top-wrapper .comment-wrap')
  if (commentWrap) {
    commentWrap.style.display = 'none'
  }
  // 隐藏“展开/收起”按钮
  const btn = document.querySelector('.retractable-wrap')
  if (btn) {
    btn.style.display = 'none'
  }
  // 展开详情
  const desc = document.querySelector('.video-desc')
  if (desc) {
    desc.classList.remove('video-desc-hidden')
  }
}

function handleTextLessonShareUrl(shareUrl, otherString) {
  const proAndText = +GetQueryString('pro_and_text')
  if (proAndText === 1) {
    let env = getRunningEnv().env
    const idMap = {
      prod: 18801, // 正式环境
      dev: 17990 // 测试环境
    }
    let playId = env ? idMap.dev : idMap.prod
    const channel_id = GetQueryString('channel_id') || ''
    shareUrl =
      window.location.protocol +
      `//m-xy${env ? '-' + env : ''}.xinli001.com` +
      `/lesson/playView?play_id=${playId}&id=989&pro_and_text=1${otherString}&channel_id=${channel_id}`
  }
  return shareUrl
}

function init() {
  // 埋点
  window.yxl.stat.send({
    name: '学院-页面访问',
    properties: {
      页面描述: `课程播放页`,
      页面title: document.title,
      业务: '学院-课程播放页',
      课程类型:
        +window.baseInfo.is_experience === 1
          ? '免费试听'
          : +window.baseInfo.is_free === 1
          ? '免费课程'
          : '付费课程',
      课程名称: window.baseInfo.lesson_title
    }
  })
  onPageViewTrack()

  let header = document.querySelector('.header-wrap')

  if (header) {
    header.style.display = 'none'
  }

  // 如果是专业课的文本课时，需要隐藏底部按钮、隐藏留言、展开详情
  const proAndText = +GetQueryString('pro_and_text')
  if (proAndText === 1) {
    handleTextLessonLayout()
  }

  initEvents()
  if (document.querySelector('.comment-puppet')) {
    let pre = null
    const model = new CommentModel({
      send(value, hide) {
        let current = Date.now()
        if (pre && current - pre <= 60000) {
          window.toast('你的操作太过频繁，请稍后再试')
          return
        }
        pre = current
        return $http
          .post(
            `${APIS.sendComment}${window.baseInfo.keshi_id}`,
            qs.stringify({
              score: 5,
              content: value
            })
          )
          .then(res => {
            const { code, message } = res.data
            if (code === 0) {
              window.toast(message)
              // document.querySelector('.bottom-fixed-wrap').style.display = 'none'
              // document.querySelector('#top-wrapper').style.bottom = 0
              // document.querySelector('#bottom-wrapper') && (document.querySelector('#bottom-wrapper').style.bottom = 0)
            } else {
              window.toast(message)
            }
            hide()
          })
      }
    })
    model.init()
  }

  if (window.baseInfo.is_text === '0') {
    initPlayer()
    initSwiper()
    document.querySelector('.video-title').style.display = 'block'
  }

  initComment()
  // 初始化微信分享
  wxShareInit()

  if (IS_APP) {
    const myBrige = new Bridge()
    myBrige.call('isPullRefreshEnable', { enable: 0 })
    $http
      .get(`${APIS.getPeriodList}?lesson_id=${window.baseInfo.lesson_id}`)
      .then(res => {
        const { code, data } = res.data
        console.log(code, data)
        if (code === 0) {
          const infos = nativeDownloadInfos([
            ...data.noParentList,
            ...data.passList
          ])
          console.log(infos)
          myBrige.call('getCourseDetailInfo', infos)
        }
      })
  }

  touchSlide()
  changeEntranceText()

  window.onload = function() {
    setTimeout(() => {
      setScrollTop(0)
      clockInit()
    }, 500)
  }
}

function changeEntranceText() {
  const downloadAppBtn = document.getElementById('downloadApp')
  if (!downloadAppBtn) {
    return
  }
  const wxOpenInAPPBtn = document.getElementsByClassName('wxOpenInAPP')[0]
  if (!$platform.isWechat) {
    wxOpenInAPPBtn.style.display = 'none'
  }
  if (!IS_APP && !isAliPay) {
    downloadAppBtn.style.display = 'block'
  }
  downloadAppBtn.addEventListener(
    'click',
    function() {
      console.log('env:', getRunningEnv().env)
      window.yxl.stat.send({
        name: `公共-App导流`,
        properties: {
          来源: '课程播放页'
        }
      })
      handleCopy('.download-app', {
        object_id: baseInfo.lesson_id,
        title: baseInfo.wx_share_config.title,
        desc: baseInfo.wx_share_config.second_title,
        url: `https://m${
          getRunningEnv().env !== '' ? '-' + getRunningEnv().env : ''
        }.xinli001.com/lesson/${baseInfo.lesson_id}`,
        type: 'lesson'
      })
      // if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      //   window.location.href =
      //     'https://itunes.apple.com/app/apple-store/id994051627?pt=1667142&ct=m5&mt=8'
      // } else {
      //   window.location.href = `https://m${
      //     getRunningEnv().env !== '' ? '-' + getRunningEnv().env : ''
      //   }.xinli001.com/download?utm_source=lessonplay`
      // }
    },
    false
  ) //鼠标单击的时候调用showMes这个函数
}

window.onerror = function(e) {
  console.log(JSON.stringify(e))
}

function preventEvent(e) {
  e.preventDefault()
}

document.body.addEventListener('touchmove', preventEvent)
document.body.addEventListener('scroll', preventEvent)
init()

initUpgradeAppVersionTips()



// WEBPACK FOOTER //
// ./src/pages/lesson/play/index.js